import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { WebAppFooter } from "./WebAppFooter";
import { NonSocialMediaIcons } from "./Icons/NonSocialMediaIcons";
import { SocialMediaIcons } from "./Icons/SocialMediaIcons";
export const WebAppFooterIcons = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const items = [
    {
      label: "Service Portals",
      key: "servicePortals",
      children: <NonSocialMediaIcons />,
    },
    {
      label: "Social Media",
      key: "socialMedia",
      children: <SocialMediaIcons />,
    },
  ];

  return (
    <Tabs
        activeKey={query?.get("thirdChildActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${query.get("subActiveTab")}&thirdChildActiveTab=${activeKey}`);
        }}
      ></Tabs>
  );
};
